// extracted by mini-css-extract-plugin
module.exports = {"button":"CartButton_button___xV10","icon":"CartButton_icon__3y4DW","badge":"CartButton_badge__2d4Ad","bump":"CartButton_bump__1LtBD"};